import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import {
  GetAllPageIDListResponsesInterface,
  QueryURLPageIDListType,
  IntoolsAccessAccessTypeType,
} from 'features/Account/@types/intoolsAccessPageIDList'

export const SLICE_NAME = 'intoolsAccessPageIDSliceName'

export interface IntoolsAccessPageIDStateInterface {
  isLoadingList: boolean
  dialogState: 'CLOSED' | 'OPEN_DIALOG_UPLOAD_JSON'
  isUploadingJSON: boolean
  pageIDListData: GetAllPageIDListResponsesInterface
  queryURL: QueryURLPageIDListType
  accessType: IntoolsAccessAccessTypeType | ''
}

export const initialState: IntoolsAccessPageIDStateInterface = {
  isLoadingList: false,
  dialogState: 'CLOSED',
  accessType: '',
  isUploadingJSON: false,
  queryURL: { sort: `updated_at`, direction: `DESC`, page_size: 10, page_index: 0, name: `` },
  pageIDListData: {
    pages: [],
    pagination: {
      direction: 'asc',
      number_of_elements: 0,
      page_index: 0,
      page_size: 0,
      sort: '',
      total_elements: 0,
      total_pages: 0,
    },
  },
}

const intoolsAccessPageIDSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: (state) => ({ ...initialState, accessType: state.accessType }),
    setLoadingList: (
      state,
      action: PayloadAction<IntoolsAccessPageIDStateInterface['isLoadingList']>,
    ) => {
      state.isLoadingList = action.payload
    },
    setIntoolsAccessPageIDList: (
      state,
      action: PayloadAction<GetAllPageIDListResponsesInterface>,
    ) => {
      state.pageIDListData = action.payload
    },
    setAdminURLQuery: (
      state,
      action: PayloadAction<IntoolsAccessPageIDStateInterface['queryURL']>,
    ) => {
      state.queryURL = action.payload
    },
    toggleDialogUploadJSON: (
      state,
      action: PayloadAction<IntoolsAccessPageIDStateInterface['dialogState']>,
    ) => {
      state.dialogState = action.payload
    },
    setIsUploadingJSON: (
      state,
      action: PayloadAction<IntoolsAccessPageIDStateInterface['isUploadingJSON']>,
    ) => {
      state.isUploadingJSON = action.payload
    },
    setAccessType: (state, action: PayloadAction<IntoolsAccessAccessTypeType>) => {
      state.accessType = action.payload
    },
  },
})

export const {
  reset,
  setIntoolsAccessPageIDList,
  setLoadingList,
  setAdminURLQuery,
  toggleDialogUploadJSON,
  setIsUploadingJSON,
  setAccessType,
} = intoolsAccessPageIDSlice.actions

export default intoolsAccessPageIDSlice.reducer
